import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from "@angular/core";
import { Actions, Store, ofActionSuccessful } from "@ngxs/store";
import {
    NotesModel,
    TourModel,
} from "@core/services/api.service";
import { ActivatedRoute } from "@angular/router";
import { AuthState } from "@ngxs-store/auth-store/auth.state";
import { Navigate } from "@ngxs/router-plugin";
import { Subject } from "rxjs";
import {
    GetTourByIdAction,
    GetTourByIdSuccessAction,
} from "@ngxs-store/managed-tour-store/managed-tour.actions";
import { Location } from "@angular/common";
import { DataSourceConfig } from "@core/models";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";

@Component({
    selector: "app-customs-view-details",
    templateUrl: "./customs-listing-view-details.component.html",
    styleUrls: ["./customs-listing-view-details.component.scss"],
})
export class CustomViewDetailsComponent implements OnInit, OnDestroy, OnChanges {
    @Output() updateDataSourceConfig = new EventEmitter<DataSourceConfig>();
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    detail: TourModel;
    notes: NotesModel[] = [];
    lat: number;
    lng: number;
    imageUrl: string;
    invLinked: boolean;

    private unsubscribe$ = new Subject();
    selectedFilterBy: string = "";
    tourId: number;
    isCustomerView = false;
    transportOrderNumber: string | null = null;

    constructor(
        private store: Store,
        private route: ActivatedRoute,
        private actions$: Actions,
        private location: Location,
        private cdr: ChangeDetectorRef
    ) {
        const s = this.route.params.subscribe((params) => {
            // Access the optional parameter from the route
            if (params["filter"]) {
                this.selectedFilterBy = params["filter"];
                this.tourId = +params["id"];
                this.invLinked = params["inventoryLinked"] === 'true';
            }
            if (params["transportOrderNumber"]) {
                this.transportOrderNumber = params["transportOrderNumber"];
            }
        });
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes.detail && changes.detail.currentValue) {
            const tour: TourModel = changes.detail.currentValue as TourModel;
            this.detail = tour;
        }
    }

    ngOnInit() {
        const token = this.store.selectSnapshot(AuthState.getDecodedToken);
        const hasCustomsRole = token?.roles?.indexOf('Customs') > -1;
        const hasCustomerOrAdmin = token?.roles?.some((r: string) => r === 'Customer' || r === 'CustomerAdmin') ?? false;
        this.isCustomerView = hasCustomerOrAdmin && !hasCustomsRole;

        this.route.params.subscribe((params) => {
            const tourId = +params["id"];

            if (params["transportOrderNumber"]) {
                this.transportOrderNumber = params["transportOrderNumber"];
            }

            const sub = this.actions$
                .pipe(ofActionSuccessful(GetTourByIdSuccessAction))
                .subscribe((action: GetTourByIdSuccessAction) => {
                    this.detail = action.payload;
                                        this.transportOrderNumber = this.detail?.transportOrderNumber ?? this.transportOrderNumber;
                    this.cdr.detectChanges();
                    sub.unsubscribe();
                });

            this.store.dispatch(new GetTourByIdAction(tourId, this.transportOrderNumber));
        });
    }


    goBack() {
        if (this.selectedFilterBy) {
            this.store.dispatch(
                new Navigate(["/customs-listing/", { filter: this.selectedFilterBy }])
            );

        } else {
            this.location.back();
        }

        this.cdr.detectChanges();
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
